import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NewProjectComponent} from './new/new-project.component';
import {ProjectComponent} from './project.component';
import {ProjectDetailComponent} from './project-detail/project-detail.component';
import {EditProjectComponent} from './edit/edit-project.component';
import {EditPropertyComponent} from './edit/properties/edit-property/edit-property.component';
import {EditLotComponent} from './edit/lot/edit-lot/edit-lot.component';
import {ProjectAnalyticsComponent} from './project-analytics/project-analytics.component';
import {ProjectCooperationComponent} from './project-cooperation/project-cooperation.component';
import {CustomerContactComponent} from './customer-contact/customer-contact.component';
/**
 * @class ProjectRoutingModule
 * @memberOf ProjectModule
 * @description This is a module which include all the components that belongs to projects
 */
const routes: Routes = [
  {
    path: '',
    component: ProjectComponent
  },
  {
    path: 'new-project',
    component: NewProjectComponent,
  },
  {
    path: 'analytics/:id',
    component: ProjectAnalyticsComponent
  },
  {
    path: 'cooperation/:id',
    component: ProjectCooperationComponent
  },
  {
    path: 'customer-contact/:id',
    component: CustomerContactComponent
  },
  {
    path: ':id',
    component: ProjectDetailComponent,
  },
  {
    path: ':id/edit',
    component: EditProjectComponent
  },
  {
    path: ':id/edit/:propertyId',
    component: EditPropertyComponent
  },
  {
    path: ':id/edit-lot/:lotId',
    component: EditLotComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectRoutingModule {
}
